import { GoabButton, GoabSpacer, GoabText } from "@abgov/react-components";
import { ErrorPage } from "../../MPP-Common-SPA/components/ErrorPage/ErrorPage";
import { getLoggedOutEndpoint } from "../../ServiceUtils/auth";
import { useLogin } from "../../PortalRunner/hooks/useLogin";

export const NotFound = ({ proxyUser = false }) => {
  // Hardcoded, as resource strings aren't always available on this page.
  const albertaSupportsCentreUrl = "https://www.alberta.ca/alberta-supports";
  const { handleLogout } = useLogin();

  return (
    <ErrorPage
      errorCode="Error 404"
      heading="The page you are looking for does not exist"
    >
      <GoabText maxWidth="none" mb="0">
        Please check the URL and try again. We apologize for the inconvenience.
      </GoabText>
      {!proxyUser && (<GoabText maxWidth="none" mb="0">
        If you need assistance, visit an{" "}
        <a href={albertaSupportsCentreUrl}>Alberta Supports Centre</a>
      </GoabText>)}
      {!proxyUser && (<GoabText maxWidth="none" mb="0">
        Or call the Alberta Supports Contact Centre at{" "}
        <a href="tel:1-877-644-9992">1-877-644-9992</a>.
      </GoabText>)}
      {proxyUser && (
        <>
          <GoabText maxWidth="none" mb="0">
            Contact <a href="mailto:EEPSupport@gov.ab.ca" style={{ color: '#0070C4', textDecoration: 'underline' }}>EEPSupport@gov.ab.ca</a> if you require assistance.
          </GoabText>
          <GoabSpacer vSpacing={"xl"} />
          <GoabButton
            type="primary"
            onClick={() => handleLogout(getLoggedOutEndpoint())}
          >
            Go to workspace
          </GoabButton>
        </>
      )}
    </ErrorPage>
  );
};

export default NotFound;
